const css = require('./styles.css');
const UserInfo = require('./user-info');
const request = require('./lib/request');

const VERSION = require('../package.json').version;
const HIDE_DELAY = 200;
const SHOW_DELAY = 500;

const OFFSET = 10;

const popupTpl = `<div class="${css.row} ${css.head}">&nbsp;</div>
<div class="${css.row}">
    <div class="${css.avatar}"></div>
    <div class="${css.body}">
        <div class="${css.spin}"></div>
    </div>
</div>
<div class="${css.row} ${css.location}"></div>`;

class StaffCardBase {
    static get version() {
        return VERSION;
    }

    constructor(element, login, options = {}) {
        if (typeof element === 'string') {
            element = document.querySelector(element);
        } else if (window.jQuery && element instanceof window.jQuery) {
            // eslint-disable-next-line no-console
            console.warn('StaffCard работает без jQuery, передайте в конструктор HTMLElement или селектор');
            element = element[0];
        }

        this.element = element;
        this.login = login;
        this.options = Object.assign({
            userInfo: {
                target: '_self'
            }
        }, options);

        this.popup = null;

        this._hideTimeout = null;
        this._showTimeout = null;

        this.onHover = this.onHover.bind(this);
        this._onLeave = this._onLeave.bind(this);
        this._onWindowMouseMove = this._onWindowMouseMove.bind(this);

        this._mouseCaptureElement();
    }
    get login() {
        return this._login;
    }
    set login(value) {
        this._login = value;
        this.userData = null;
    }
    /**
     * Обработка наведения крусора на element
     */
    onHover() {
        this._startShow();
    }
    /**
     * Обработка убирания курсора с элемента
     * @private
     */
    _onLeave() {
        this._startHide();
    }
    /**
     * Удаляет popup из DOM, предварительно остановив все таймеры
     */
    destruct() {
        this._cancelShow();
        this._cancelHide();
        this._delPopup();
    }
    /**
     * Возвращает z-index для попапа
     * Берётся наибольшый z-index родителей + 1, но не меньше 100
     * @private
     * @returns {Number}
     */
    _zIndex() {
        let parent = this.element.parentNode;
        let zIndex = 100;

        while (parent && parent !== document.body) {
            let ParentZIndex = window.getComputedStyle(parent).getPropertyValue('z-index');

            if (!isNaN(ParentZIndex)) {
                zIndex = Math.max(zIndex, ParentZIndex);
            }

            parent = parent.parentNode;
        }

        return zIndex + 1;
    }
    /**
     * Отмена скрытия попапа
     * @private
     */
    _cancelHide() {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
    }
    /**
     * Скрытие попапа
     * @private
     */
    _startHide() {
        this._cancelHide();
        this._cancelShow();
        this._hideTimeout = setTimeout(() => {
            if (!this.popup) {
                return;
            }
            
            this.popup.classList.remove(css.popup_visible);
            const listener = () => {
                this.popup.removeEventListener('transitionend', listener);
                this._delPopup();
            };
            this.popup.addEventListener('transitionend', listener);
        }, HIDE_DELAY);
    }
    /**
     * Отмена открытия попапа
     * @private
     * */
    _cancelShow() {
        clearTimeout(this._showTimeout);
        this._showTimeout = null;
    }
    /**
     * Открытие попапа
     * @private
     * */
    _startShow() {
        this._cancelHide();
        this._cancelShow();
        this._showTimeout = setTimeout(() => {
            this.popup = this._createPopup();

            this._position(true);
            this.popup.classList.add(css.popup_visible);
            this._requestData()
                .then(data => {
                    this._renderUser(data);
                    this._position(false);
                })
                .catch(() => this._renderError());
        }, SHOW_DELAY);
    }
    /**
     * Обработка движения курсора над window
     * @param {Event} e
     * @private
     */
    _onWindowMouseMove(e) {
        function check(elem) {
            return elem === e.target || (elem !== e.target && elem.contains(e.target));
        }

        if (check(this.popup) || check(this.element)) {
            this._cancelHide();
        } else {
            this._startHide();
        }
    }
    /**
     * Позиционирование попапа
     * @param {Boolean} forceLayout — принудительная перерисовка
     * @private
     */
    _position(forceLayout) {
        if (forceLayout) {
            this.popup.style.transition = 'none';
        }

        this.popup.style.top = 0;
        this.popup.style.left = 0;
        const popupWidth = this.popup.offsetWidth;
        const popupHeight = this.popup.offsetHeight;
        const documentWidth = document.documentElement.clientWidth;
        const windowHeight = window.innerHeight;
        let sideClass;
        let {top, left, right, bottom, width } = this.element.getBoundingClientRect();
        const elementHeight = top - bottom;

        left += window.pageXOffset;
        right += window.pageXOffset;

        const isFitsRight = documentWidth - right - OFFSET >= popupWidth;
        const isFitsLeft = left - OFFSET >= popupWidth;

        if (isFitsRight) {
            sideClass = css.popup_side_right;
            left += width;
        } else if (isFitsLeft) {
            sideClass = css.popup_side_left;
            left -= popupWidth; 
        } else {
            sideClass = css.popup_side_right;
            // двойной отступ, так как сам popup тоже с OFFSET
            left += Math.max(OFFSET, documentWidth - left - OFFSET - popupWidth); 
        }

        // отображать под элементом
        if (!isFitsRight && !isFitsLeft) top += elementHeight;

        //vertical alignment
        if ((windowHeight - (top + popupHeight) < 0) && (windowHeight > popupHeight)) {
            if (bottom > windowHeight) {
                top = windowHeight - popupHeight;
            }
            else {
                top = bottom - popupHeight;
            }
        }
        top += window.pageYOffset;

        this.popup.classList.remove(css.popup_side_left, css.popup_side_right);
        this.popup.classList.add(sideClass);
        this.popup.style.top = `${top}px`;
        this.popup.style.left = `${left}px`;
        this.popup.style.zIndex = this._zIndex();
        if (forceLayout) {
            //force update layout to get correct animation
            window.getComputedStyle(this.popup).getPropertyValue('transform');
            this.popup.style.transition = '';
        }
    }
    /**
     * Создание попапа
     * @returns {HTMLElement}
     * @protected
     */
    _createPopup() {
        const popup = document.createElement('div');
        popup.innerHTML = popupTpl;
        popup.classList.add(css.popup);
        document.body.appendChild(popup);

        this._mouseCaptureWindow();

        return popup;
    }
    /**
     * Удаляет popup из DOM
     * @protected
     * */
    _delPopup() {
        this._mouseCaptureElement();

        if (!this.popup) {
            return;
        }

        this.popup.parentNode.removeChild(this.popup);
        this.popup = null;
    }
    /**
     * Включить проверку положения курсора над попапом
     * @private
     */
    _mouseCaptureWindow() {
        this.element.removeEventListener('mouseenter', this.onHover);
        this.element.removeEventListener('mouseleave', this._onLeave);
        window.addEventListener('mousemove', this._onWindowMouseMove);
    }
    /**
     * Включить проверку положения курсора над элементом
     * @private
     */
    _mouseCaptureElement() {
        this.element.addEventListener('mouseenter', this.onHover);
        this.element.addEventListener('mouseleave', this._onLeave);
        window.removeEventListener('mousemove', this._onWindowMouseMove);
    }
    /**
     * Получение данных пользователя
     * @returns {Promise}
     * @private
     */
    _requestData() {
        if (!this.userData) {
            this.userData = request.getJSON(`//center.yandex-team.ru/api/staff_cards/?${this.login}&format=json`);
        }
        return this.userData;
    }
    /**
     * Отрисовка контента попапа
     * @param data
     * @private
     */
    _renderUser(data) {
        const user = data[this.login];
        if (!user) {
            return this._renderError();
        }
        new UserInfo(this.popup, user, this.options.userInfo);
    }
    /**
     * Отрисовка ошибки
     * @private
     */
    _renderError() {
        this.userData = null;
        if (!this.popup) {
            return;
        }
        this.popup.querySelector(`.${css.avatar}`).classList.add(css.avatar_error);
        this.popup.querySelector(`.${css.body}`).innerHTML = '<b>Ooops!</b>';
    }
}

export default StaffCardBase;



// WEBPACK FOOTER //
// ./src/staff-card-base.js